module.exports = __webpack_public_path__ + "img/utilityhydrant_stopped.14701298.svg";